/*
 * PAWS & PEARLS — Candy Dreams, Pearl Blossom from the upper-right corner V2
 * NEW independent addition. 8 existing botanical frames, unchanged drawings.
 * The visible flower is not centred in its 480px canvas; each frame is therefore
 * scaled from the top-right anchor to make the bud originate from the corner.
 * Owner explicitly confirmed NO previous pearl-flower code was installed.
 * Never modify the existing rose, butterfly, vine, petals, curtain or sound.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || !script.dataset.ppPearlCornerV2Frames) return;
  var sources = script.dataset.ppPearlCornerV2Frames.split('|').map(function (url) {
    return url.trim();
  }).filter(Boolean);
  if (sources.length !== 8) {
    console.warn('[P&P Pearl Corner V2] Exactly eight frames are required.');
    return;
  }
  // Fail closed: run only on Candy Dreams, never the Homepage or Our World.
  if (!/(?:^|\/)collections\/candy-dreams\/?$/i.test(location.pathname)) return;

  var DIVIDER = '.pp-candy-floral-divider';
  var ROSE = 'pp-candy-first-hanging-rose-v1';
  var CLASSNAME = 'pp-candy-pearl-bloom-from-corner-v2';
  var AFTER_ROSE_NEAR_FINISH_MS = 1900;
  var FRAME_MS = 630;
  // Intentionally not interpolating artwork: House animations are theatrical,
  // and the visible size step creates an inward/downward blooming effect.
  var SCALES = [0.22, 0.37, 0.49, 0.61, 0.73, 0.83, 0.93, 1.0];
  var mounted = new WeakSet();
  var reducedMotion = Boolean(window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var readyImages = Promise.all(sources.map(function (src) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () { resolve(true); };
      image.onerror = function () { reject(new Error(src)); };
      image.src = src;
      if (image.complete && image.naturalWidth > 0) resolve(true);
    });
  })).then(function () { return true; }, function (error) {
    console.warn('[P&P Pearl Corner V2] Missing frame; no blossom displayed.', error);
    return false;
  });

  function findHero() {
    var divider = document.querySelector(DIVIDER);
    if (!divider) return null;
    var section = divider.closest('[id^="shopify-section-"]') ||
      divider.closest('.shopify-section');
    if (!section) return null;
    var hero = section.nextElementSibling;
    if (!hero || !hero.matches('[id^="shopify-section-"],.shopify-section') ||
        !hero.querySelector('img,picture,video')) return null;
    return hero;
  }

  // Observe the REAL existing rose's stage, not an unrelated clock or timer.
  function roseAlmostFinished(rose) {
    var pos = rose.style.backgroundPosition || '';
    var parsed = pos.match(/^\s*([\d.]+)%\s+([\d.]+)%/);
    return Boolean(parsed && Number(parsed[2]) >= 99 && Number(parsed[1]) >= 65);
  }

  function makeLayer(hero) {
    if (!hero.isConnected || hero.querySelector('.' + CLASSNAME)) return null;
    if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    var layer = document.createElement('div');
    layer.className = CLASSNAME;
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = [
      'position:absolute', 'inset:0', 'z-index:7', 'overflow:hidden',
      'pointer-events:none', 'user-select:none'
    ].join(';') + ';';
    var img = document.createElement('img');
    img.alt = '';
    img.draggable = false;
    img.decoding = 'async';
    img.style.cssText = [
      'position:absolute', 'right:0', 'top:0',
      'width:clamp(86px,11.6vw,178px)', 'max-width:none', 'height:auto',
      'display:block', 'pointer-events:none', 'user-select:none',
      'transform-origin:100% 0%', 'transform:scale(0.22)',
      'will-change:transform'
    ].join(';') + ';';
    layer.appendChild(img);
    hero.appendChild(layer);
    return img;
  }

  function setPose(img, n) {
    img.src = sources[n];
    img.style.transform = 'scale(' + SCALES[n] + ')';
  }

  function install(hero) {
    if (mounted.has(hero)) return;
    mounted.add(hero);

    var roseObserver = null;
    var waitObserver = null;
    var started = false;
    var delayTimer = null;
    function stopObserving() {
      if (roseObserver) { roseObserver.disconnect(); roseObserver = null; }
      if (waitObserver) { waitObserver.disconnect(); waitObserver = null; }
    }

    if (reducedMotion) {
      readyImages.then(function (okay) {
        if (!okay || !hero.isConnected) return;
        var still = makeLayer(hero);
        if (still) setPose(still, 7);
      });
      return;
    }

    function run() {
      if (started) return;
      started = true;
      stopObserving();
      delayTimer = window.setTimeout(function () {
        readyImages.then(function (okay) {
          if (!okay || !hero.isConnected || hero.querySelector('.' + CLASSNAME)) return;
          var img = makeLayer(hero);
          if (!img) return;
          var startedAt = null;
          var pausedAt = null;
          var oldIndex = -1;
          var raf = 0;
          function cleanup() {
            window.cancelAnimationFrame(raf);
            document.removeEventListener('visibilitychange', visibilityChanged);
          }
          function tick(now) {
            if (!hero.isConnected || !img.isConnected) { cleanup(); return; }
            if (document.hidden) return;
            if (startedAt === null) startedAt = now;
            var index = Math.min(7, Math.floor((now - startedAt) / FRAME_MS));
            if (index !== oldIndex) {
              setPose(img, index);
              oldIndex = index;
            }
            if (index < 7) raf = window.requestAnimationFrame(tick);
            else cleanup(); // Remain fully bloomed until section is removed.
          }
          function visibilityChanged() {
            if (document.hidden) {
              pausedAt = performance.now();
              window.cancelAnimationFrame(raf);
            } else {
              if (pausedAt !== null && startedAt !== null) {
                startedAt += performance.now() - pausedAt;
              }
              pausedAt = null;
              raf = window.requestAnimationFrame(tick);
            }
          }
          document.addEventListener('visibilitychange', visibilityChanged);
          if (!document.hidden) raf = window.requestAnimationFrame(tick);
        });
      }, AFTER_ROSE_NEAR_FINISH_MS);
    }

    function observeRose(rose) {
      if (waitObserver) { waitObserver.disconnect(); waitObserver = null; }
      roseObserver = new MutationObserver(function () {
        if (roseAlmostFinished(rose)) run();
      });
      roseObserver.observe(rose, { attributes:true, attributeFilter:['style'] });
      if (roseAlmostFinished(rose)) run();
    }
    var rose = hero.querySelector('.' + ROSE);
    if (rose) observeRose(rose);
    else {
      waitObserver = new MutationObserver(function () {
        var found = hero.querySelector('.' + ROSE);
        if (found) observeRose(found);
      });
      waitObserver.observe(hero, { childList:true, subtree:true });
    }
  }

  function mount() {
    var hero = findHero();
    if (hero) install(hero);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, {once:true});
  } else mount();
  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(mount);
  });
})();
